import service from './Setting'



//取得試算金額
export const TakePreBill = (obj) => service.post('/Order/TakePreBill',obj);


//取得最後確認帳單資訊
export const TakeBill = (obj) => service.post('/Order/TakeBill',obj);

//新增訂單
export const AddNewOrder = (obj) => service.post('/Order/AddNewOrder',obj);

//取消訂單
export const PostCancel = (obj) => service.post('/Order/PostCancel',obj);

//回傳備案資料（事故備案紀錄）
export const TakeFiling = (obj) => service.post('/Order/TakeFiling',obj);

// GetTokenbyTrade
export const GetTokenbyTrade = (obj) => service.post('/ECPay/GetTokenbyTrade',obj);


// ECPayDataEncrypt
export const ECPayDataEncrypt = (obj) => service.post('/ECPay/ECPayDataEncrypt',obj);

//建立訂單，付款
export const CreatePayment = (obj) => service.post('/ECPay/CreatePayment',obj);


//取得訂單
export const GetOrderInfo = (id) => service.get(`/Order/GetOrderInfo/${id}`);




export const TakeCancel = (obj) => service.post(`/Order/TakeCancel`,obj);



//完成新增訂單後的意見回饋
export const FeedBack = (obj) => service.post(`/Order/FeedBack`,obj);

